import React, { useEffect, useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem
} from "@mui/material";
import { useDeleteServerMutation, useGetServerQuery, useGetDomainQuery,useGetDomainProviderQuery,
  useGetCustomerQuery, useCreateDomainMutation, useDeleteDomainMutation
  } from "../../../Api/attoDeskApi";
import { IServers, IDomains, IDomainProviders ,ICustomer} from "../../../Api/Interface/api.interface";
import NewPopUpTax from "../../Domain/Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import moment from 'moment';
import axios from "axios";
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useFormik } from "formik";


const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
const { id } = useParams<{ id: string }>();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const API_URL = process.env.REACT_APP_API_URL;
  const [selectedCoursing, setSelectedCoursing] = useState<IDomains | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IDomains | null>(null);
  const [selectedDomain, setSelectedDomain] = useState("");
const [expiryDate, setExpiryDate] = useState("");
  const [renewalCost, setRenewalCost] = useState("");
const [allocatedList, setAllocatedList] = useState<any[]>([]);
const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
      useState<string>("");
const [newDomain, { isLoading }] = useCreateDomainMutation();
const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | null>(null);
const [showDropdownCustomer, setShowDropdownCustomer] =
        useState<boolean>(false);
const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
const [showCustomerError, setShowCustomerError] = React.useState(false);

  const { data, isLoading: serverAllLoading, isError, refetch } = useGetServerQuery({
    searchText: currentSearchQuery,
  });

  const { 
  data: domainProviderData, 
  isLoading: domainproviderLoading, 
  isError: domainProviderError, 
  refetch: domainProviderRefresh 
} = useGetDomainProviderQuery({
  id: id,              
  searchText: "",     
});

const { 
  data: serverData, 
  isLoading: serverLoading, 
  isError: serverError, 
  refetch: serverRefresh 
} = useGetServerQuery({
  id: id,              
  searchText: "",     
});


const { 
  data: domainData, 
  isLoading: domainLoading, 
  isError: domainError, 
  refetch: domainRefresh 
} = useGetDomainQuery({
    searchText: "",
  });

    const {
        data: customerData,
        isLoading: customerIsLoading,
        isError: cutomerError,
        refetch: cutomerRefetch,
      } = useGetCustomerQuery({
        searchText: currentSearchQueryCustomer,
        id: "",
      });

      const coursings: IServers[] = Array.isArray(data?.data)
    ? (data?.data as IServers[])
    : [];

       const customerList: ICustomer[] = Array.isArray(customerData?.data)
          ? (customerData?.data as ICustomer[])
          : [];

      const domainProviderDetail: IDomainProviders[] = Array.isArray(domainProviderData?.data)
    ? (domainProviderData?.data as IDomainProviders[])
    : [];

    useEffect(() => {
  if (domainProviderDetail.length > 0 && !formik.values.domainProviderId) {
    formik.setFieldValue("domainProviderId", domainProviderDetail[0].id); 
  }
}, [domainProviderDetail]);

  const serverDetail: IServers[] = Array.isArray(serverData?.data)
    ? (serverData?.data as IServers[])
    : [];

  const domainList: IDomains[] = Array.isArray(domainData?.data)
    ? (domainData?.data as IDomains[])
    : [];

  
  const formik = useFormik({
    initialValues: {
      customerId:"",
      name: "",
      domainProviderId: "",
      expiryDate: null,
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
        domainProviderId: String(values.domainProviderId),
        customerId: selectedCustomer?.id,
        name: values.name,
         expiryDate: values.expiryDate,
        };

        const addCompanyResponse = await newDomain(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage("Domain Created successfully");
          resetForm();
          setSelectedCustomer(null);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.customerId && formik.values.customerId.trim() !== "" ||
    formik.values.name && formik.values.name.trim() !== ""
      ? true
      : false;
  }, [formik]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IDomains) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IDomains) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const [deleteCategory] = useDeleteDomainMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the server");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the server");
    }
  };

  // if (isLoading)
  //   return (
  //     <Box
  //       display="flex"
  //       justifyContent="center"
  //       alignItems="center"
  //       height="10vh"
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );

  


const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

   const filterOptions = createFilterOptions({
              matchFrom: 'any', // Match anywhere in the string
              stringify: (option: any) => {
                if (typeof option === 'string') return option;
                // Combine fields for searching
                return `${option.customerFirstName} ${option.customerLastName} ${option.customerMobileNum}`;
              },
            });


  const handleAddProductClick = () => {
    navigate("/server/create");
  };

    const handleSelectCustomer = (customerId: string) => {
    const selectedCustomer = customerList.find(
      (customer) => String(customer.id) === customerId
    );
    if (selectedCustomer) {

      const customerFormattedAddress = customerFormatAddress(
        selectedCustomer.customerStreetNumber || "",
        selectedCustomer.customerStreetName || "",
        selectedCustomer.customerCity || "",
        selectedCustomer.customerProvince || "",
        selectedCustomer.customerPostalCode || "",
      );

      setSearchQueryCustomer(
        // (selectedCustomer.customerFirstName || " ") +
        //   " " +
        //   (selectedCustomer.customerLastName || " ")
        selectedCustomer.customerCompanyName
      );

      formik.setFieldValue(
        "customerCompanyName",
        selectedCustomer.customerCompanyName  || ""
      );
        formik.setFieldValue(
        "customerFirstName",
        selectedCustomer.customerFirstName || ""
      );
      formik.setFieldValue(
        "customerLastName",
        selectedCustomer.customerLastName || ""
      );
      formik.setFieldValue(
        "customerMobileNum",
        selectedCustomer.customerMobileNum || ""
      );
      formik.setFieldValue("customerEmail", selectedCustomer.customerEmail|| "");
      
      formik.setFieldValue("customerAddress", customerFormattedAddress|| "");
      formik.setFieldValue("quoteWorkOrderCustomerId", selectedCustomer.id);
    }
    setShowDropdownCustomer(false);
  };

    const customerFormatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    if (!streetNumber && !streetName && !city && !province && !postalCode) {
      return ""; // Return an empty string if all fields are empty
    }

    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };



// Delete allocation
const handleDeleteAllocation = async (domainId: any) => {
  const updatedList = allocatedList.filter(d => d.domainId !== domainId);

  try {
    await axios.post(`${API_URL}/server/allocate-domain`, {
      id,
      allocatedDomains: updatedList, // send full updated list
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
    });

    setAllocatedList(updatedList);
    showMessage("Domain removed successfully");
    domainRefresh();
  } catch (error) {
    console.error(error);
    showErrorMessage("Failed to remove domain");
  }
};



        

  return (

    <><Card className={classes.card} sx={{ mb: 3 }}>
      <Grid
        container
        spacing={2}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
       
  {isError || domainProviderDetail.length === 0 ? (
    <Grid item xs={12} textAlign="center">
      {isError ? "Error fetching data" : "No data available"}
    </Grid>
  ) : (
    domainProviderDetail
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((row: IDomainProviders, index) => (
        <Card key={row.id} className={classes.card} sx={{ mb: 2, p: 2 }}>
  <Grid container spacing={3}>
    {[
      { label: 'Name', value: row.name ?? '-' },
      { label: 'Customer', value: row.customer?.customerFirstName ?? '-' },
      { label: 'Company', value: row.company?.name ?? '-' },
      { label: 'ID', value: row.domainProviderId ?? '-' },
      { label: 'Expiry Date', value: row.expiryDate ? moment(row.expiryDate).format('DD-MMM-YY') : '-' },
    ].map((field) => (
      <Grid item xs={12} sm={6} md={4} key={field.label}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="body1"
            component="span"
            sx={{ width: 120, fontWeight: 'bold' }} // bold and fixed width for alignment
          >
            {field.label}
          </Typography>
          <Typography variant="body1" component="span">
            {field.value}
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
</Card>

      ))
  )}
</Grid>

    </Card>
    
    <Card className={classes.card}>
        <Grid
          container
          spacing={2}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Domain Details</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              {/* <Grid item>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Name & Code .."
                  sx={{ width: "100%" }}
                  size="small" />
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  className={classes.addButton}
                  onClick={handleAddProductClick}
                >
                  Add Server
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>

  <Grid container spacing={2} sx={{ p: 4 }}>
    
    <Grid item xs={12} sm={3}>
        <Autocomplete
                         options={customerList}
                        getOptionLabel={(option) => {
                       if (typeof option === 'string') return option;
                       const name = `${option.customerFirstName || ''} ${option.customerLastName || ''}`;
                       const company = option.customerCompanyName ? ` (${option.customerCompanyName})` : '';
                       return `${name}${company}`;
                     }}
                     
                         filterOptions={filterOptions}
                         value={selectedCustomer || null}
                         onChange={(event, newValue) => {
                           if (typeof newValue === 'object' && newValue !== null) {
                             setSelectedCustomer(newValue);
                             handleSelectCustomer(String(newValue.id));
                             setSearchQueryCustomer(`${newValue.customerFirstName} ${newValue.customerLastName}`);
                           } else if (typeof newValue === 'string') {
                             setSearchQueryCustomer(newValue);
                             setSelectedCustomer(null);
                             handleSelectCustomer("");
                           }
                         }}
                         onInputChange={(event, newInputValue) => {
                           setSearchQueryCustomer(newInputValue);
                           if (newInputValue === '') {
                             setSelectedCustomer(null);
                           }
                         }}
                         renderInput={(params) => (
                           <TextField
                             {...params}
                             value={searchQueryCustomer}
                             onChange={(e) => setSearchQueryCustomer(e.target.value)}
                             placeholder="Search Customer"
                             size="small"
                         error={showCustomerError && !selectedCustomer}
                       helperText={showCustomerError && !selectedCustomer ? "Customer selection is required" : ""}
                             InputProps={{
                               ...params.InputProps,
                               startAdornment: (
                                 <InputAdornment position="start">
                                   <Box sx={{ pr: 2 }}>
                                     <CiSearch className={classes.searchWidgetIcon} />
                                   </Box>
                                 </InputAdornment>
                               ),
                            
                             }}
                             sx={{
                               width: "100%",
                               border: 'none !important',
                               color: 'theme.palette.primary.main',
                             }}
                           />
                         )}
                       />
    </Grid>

    <Grid item xs={12} sm={3}>
     <TextField
      label="Domain Name"
        InputLabelProps={{ shrink: true }}
                              
                                size="small"
                                {...formik.getFieldProps("name")}
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                               
                              />
    </Grid>

   <Grid item xs={12} sm={3}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label="Expiry Date" // Add label here
      value={formik.values.expiryDate}
      onChange={(date) => formik.setFieldValue("expiryDate", date)}
      slotProps={{
        textField: {
          size: "small", // same as your TextField
          sx: { width: "100%" },
          InputProps: {
            sx: { fontSize: 14 }, // same font size
          },
          InputLabelProps: {
            shrink: true,       // make it shrink
            sx: { fontSize: 14 } // same font size as TextField label
          },
          ...formik.getFieldProps("expiryDate"), // optional if you want formik binding
        },
      }}
    />
  </LocalizationProvider>
</Grid>

    

    <Grid item xs={12} sm={3} display="flex" alignItems="center">
      <Button
        variant="contained"
          onClick={() => formik.handleSubmit()}
          className={classes.addButton}
      >
        Create
      </Button>
    </Grid>
  </Grid>



        <Grid>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                  {/* <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                  </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>#</strong>
                  </TableCell>
                   <TableCell className={classes.tablheader}>
                    <strong>Domain Provider</strong>
                  </TableCell>
                    <TableCell className={classes.tablheader}>
                    <strong>Customer</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Domain Name</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Domain Expiry Date</strong>
                  </TableCell>
                
                  <TableCell
                    className={classes.tablheader}
                    sx={{ textAlign: "right" }}
                  >
                    <strong>Actions</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || domainList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {isError ? "Error fetching data" : "No data available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  domainList
                  .filter((row: IDomains) => String(row.domainProviderId) === id) 
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IDomains, index) => (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        
                        <TableCell scope="row" className={classes.tablCell}>
                          {/* {row.domain_provider?.name??  "-"} */}
                         {row.domain_provider?.customer?.customerFirstName} - {row.domain_provider?.company?.name} - {row.domain_provider?.domainProviderId}
                        </TableCell>

                           <TableCell scope="row" className={classes.tablCell}>
                         {row.customer ? row.customer.customerFirstName : "-"}
                        </TableCell>

                         <TableCell scope="row" className={classes.tablCell}>
                          {row.name}
                        </TableCell>

                        {/* Expiry Date */}
                        <TableCell scope="row" className={classes.tablCell}>
                          {row.expiryDate ? moment(row.expiryDate).format('DD-MMM-YY') : "-"}
                        </TableCell>


                        <TableCell className={classes.tablCell}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                                onClick={() => handleOpenDialog(row)}
                              >
                                <EditSharpIcon className={classes.editListIcon} />
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.deleteButtonList}
                                 onClick={() => handleOpenDeletePopup(row)}
                              >
                                <DeleteOutlineSharpIcon
                                  className={classes.deleteListIcon} />
                              </Button>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
            <Grid
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination
                  count={coursings.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>
          {selectedCoursing && (
            <NewPopUpTax
              openModel={openDialog}
              handleCloseDialog={handleCloseDialog}
               data={selectedCoursing} 
              />
          )}
          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete?.id.toString());

              } }
              title="Delete Server"
              content={`Are you sure you want to delete "${coursingToDelete.name}"?`} />
          )}
        </Grid>
      </Card></>
  );
};

export default Index;
